module.exports = __webpack_public_path__ + "img/dentaltwin_logo.e4e3db8f.svg";